import React from 'react'
import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import avatar from '../img/avatar.png';
import { ImGithub, ImLinkedin2, ImInstagram } from 'react-icons/im';


function Navigation() {
    
    return (
        <NavigationStyled>
            <div className="avatar">
                <img src={avatar} alt=""/>
                <h1 className="title-logo">Dika</h1>
                <p className="title-desc">Web Developer</p>
            </div>
            <ul className="nav-items">
                <li className="nav-item">
                    <NavLink to="/" activeClassName="active-class" exact>Home</NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/about" activeClassName="active-class" exact>About</NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/skills" activeClassName="active-class" exact>Skills</NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/works" activeClassName="active-class" exact>Works</NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/contact" activeClassName="active-class" exact>Contact</NavLink>
                </li>
                <div className="icons">
                    <a href="https://github.com/dhikad19" target="_blank" rel="noopener noreferrer" className="icon i-facebook">
                        <ImGithub />
                    </a>
                    <a href="https://www.linkedin.com/in/dwiandikaa/" target="_blank" rel="noopener noreferrer" className="icon i-github">
                        <ImLinkedin2 />
                    </a>
                    <a href="https://www.instagram.com/dikad19/" target="_blank" rel="noopener noreferrer" className="icon i-youtube">
                        <ImInstagram />
                    </a>
                </div>
            </ul>
            <footer className="footer">
                <p>{new Date().getFullYear()} © <b>dhikad19</b></p>
            </footer>
        </NavigationStyled>
    )
}

const NavigationStyled = styled.nav`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    border-right: 1px solid var(--border-color);
    .avatar{
        width: 100%;
        border-bottom: 1px solid var(--border-color);
        text-align: center;
        padding: 1rem 0;
        img{
            width: 70%;
        }
    .title-logo{
        font-weight: bold; 
        font-size: 25px;
        margin-top: -5px;
        color: var(--font-light-color);
    }
    .title-desc{
        font-size: 15px;
        margin-top: 12px;
        color: #c46500;
    }
    }

    .nav-items{
        width: 100%;
        text-align: center;
        transition: none;
        .active-class{
            background-color: var(--primary-color-light);
            color: white;
        }
        li{
            display: block;
            a{
                display: block;
                padding: 1rem 0;
                position: relative;
                z-index: 10;
                text-transform: uppercase;
                transition: all .4s ease-in-out;
                font-weight: 300;
                letter-spacing: 1px;
                &:hover{
                    cursor: pointer;
                }
                &::before{
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 0;
                    height: 50%;
                    background-color: #c46500;
                    transition: All 0.4s cubic-bezier(1,-0.2,.25,.95) ;
                    opacity: 0.21;
                    z-index: -1;
                }
            }

            a:hover::before{
                width: 100%;
                height: 100%;
            }
        }
    }

    .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all .4s ease-in-out;
                cursor: pointer;
                font-size: 17px;

                &:hover{
                    color: var(--primary-color);
                }
                &:not(:last-child){
                    margin-right: 5px;
                }
                svg{
                    margin: 5px;
                }
            }

            .i-youtube{
                &:hover{
                    color: #c46500;
                }
            }
            .i-github{
                &:hover{
                    color: #c46500;
                }
            }
    }
    footer{
        border-top: 1px solid var(--border-color);
        width: 100%;
        p{
            padding: 1.3rem 0;
            font-size: 12px;
            display: block;
            text-align: center;
        }
    }

    
`;
export default Navigation;
